export default __webpack_public_path__ + "static/media/fi-br-user.85de5085.svg";